<template>
  <v-row class="ma-0 pa-0 mt-10 mb-10" justify="space-between" style="font-weight:500;">
    <v-col class="ma-0 pa-0" cols="8" style="text-align: start; font-size: 0.9rem;">
      <v-row class="ma-0 pa-0">
        ＜利用上の注意＞
      </v-row>
      <v-row class="ma-0 pa-0 pb-2">
        ※構成比は小数点以下を四捨五入しているため、合計しても必ずしも100％とはならない場合があります。
      </v-row>
      <v-row class="ma-0 pa-0">
        ※当日の時間別集計の数値は、カメラからのデータが時間を跨いで遅れて受信する場合等に多少の誤差が発生する場合がありますので予めご了承ください。
      </v-row>
      <v-row class="ma-0 pa-0 pl-4">
        尚、毎日深夜1時5分より前日分のデータを再計算してグラフを再表示していますので、より正確な数値を確認したい場合は、翌日2：00以降に表示されるデータをご利用ください。
      </v-row>
    </v-col>
    <v-col v-if="fileDownloadStatus == 'makeFile'" class="ma-0 pa-0" cols="auto" 
    style="text-decoration:underline;color:#008DD0;cursor:pointer;" @click="clickFileDownload">
      {{ta('fileDownload')}}
    </v-col>
    <v-col v-else-if="fileDownloadStatus == 'filePreparing'" class="ma-0 pa-0" cols="auto">
      <v-row class="ma-0 pa-0" style="position:relative;">
        <v-img src="@/assets/images/progress_circle.gif" class="progress_circle"></v-img>
        {{ta('filePreparing')}}
      </v-row>
    </v-col>
    <v-col v-else-if="fileDownloadStatus == 'downloadReady'" class="ma-0 pa-0" cols="auto">
      <v-row class="ma-0 pa-0 mb-2" justify="end" style="font-size:0.9rem;">
        {{ta('downloadReady')}}
      </v-row>
      <v-row class="ma-0 pa-0" justify="end">
        <v-col class="ma-0 pa-0" cols="auto">
          <v-row class="ma-0 pa-0" justify="end">
            <v-col class="ma-0 pa-0">
              <v-btn id="blue_btn" class="pa-5 pl-15 pr-15" @click="toDownloadSuccess" style="font-size:1.1rem;"
                :href="fileDownloadLink" download>
                <v-img src="@/assets/images/icon_file_download.png" width="1.5rem"></v-img>
                {{ta('csvDownload')}}
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0 mt-2 modeText" justify="start">
            <v-col class="ma-0 pa-0 pl-2" cols="3">
              {{ta('period')}} :
            </v-col>
            <v-col class="ma-0 pa-0" cols="9" align-self="start">
              {{getDateToTextFormat()}}
            </v-col>
          </v-row>
          <v-row class="ma-0 pa-0 modeText" justify="start">
            <v-col class="ma-0 pa-0 pl-2" cols="3">
              {{ta('mode')}} :
            </v-col>
            <v-col class="ma-0 pa-0" cols="9" align-self="start">
              {{modeText}}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col v-else-if="fileDownloadStatus == 'downloadFail'">
      <v-row class="ma-0 pa-0 mb-2" justify="end">
        {{ta('downloadRetry')}}
      </v-row>
      <v-row class="ma-0 pa-0" justify="end">
        <v-col class="ma-0 pa-0" cols="auto">
          <v-row class="ma-0 pa-0" justify="end">
            <v-btn id="grey_btn" style="border-radius:0px;font-size:1.1rem;" class="pa-5 pl-11 pr-11" @click="toMakeFile">
              <v-img src="@/assets/images/icon_warning.png" style="width: 2rem;" class="mr-1"></v-img>
              {{ta('downloadFail')}}
              <v-img class = "btn_close" style="right: -2.7rem" src="@/assets/images/popup_close.png"></v-img>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col v-else-if="fileDownloadStatus == 'downloadSuccess'">
      <v-row class="ma-0 pa-0" justify="end">
        <v-btn id="grey_btn" style="border-radius:0px;" class="pl-10 pr-10" @click="toMakeFile">
          {{ta('downloadSuccess')}} <v-img class = "btn_close" src="@/assets/images/popup_close.png"></v-img>
        </v-btn>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import mixin from '@/mixin';
export default {
	props: {
    modeData: {type: String},
    periodData: {type: String},
    pageName: {type: String},
    leftSide: {type: Object},
    startDate: {type: Object},
    endDate: {type: Object}
  },
	mixins: [mixin.common],
	data: () => ({
    fileDownloadStatus: 'makeFile',
    /* fileDownloadStatus
      1. makeFile : 파일 작성
      2. filePreparing : 파일 작성 중
      3. downloadReady : 다운로드 준비 완료
      4-1. downloadFail : 다운로드 실패
      4-2. downloadSuccess : 다운로드 성공
    */
    fileDownloadData: {},
    mode: 'day',
    period: '7day',
    modeText: '日別',
    periodText: '日別',
    fileDownloadFrom: '', //파일 다운로드 기간 from
    fileDownloadTo: '', //파일 다운로드 기간 to
	}),
  watch: {
    modeData: function(item) {
      this.mode = item;
      if(!(this.fileDownloadStatus == 'filePreparing' || this.fileDownloadStatus == 'downloadReady')){
        this.refreshFileDownload();
      }
    },
    periodData: function(item) {
      this.period = item;
      this.refreshFileDownload(); //period 변경 시에만 file download refresh
    },
  },
  created() {
		this.unisCustomerCd = this.$store.getters.getUserunisCustomerCd;
    this.refreshFileDownload();
  },
  mounted() {
    this.getFileDownloadData();
  },
  methods: {
		ta(t) {
      return this.$t("lang.allStoreAnalytics." + t);
    },
    clickFileDownload() {
      this.fileDownloadStatus = 'filePreparing'
      this.getAnalyticsFileDownload();
    },
    getDateToTextFormat() { //다운로드 버튼 밑 기간 text 생성
      let testFormatFrom = this.fileDownloadFrom.substring(0,4) + '/' + this.fileDownloadFrom.substring(4,6) + '/' + this.fileDownloadFrom.substring(6,8);
      let testFormatTo = this.fileDownloadTo.substring(0,4) + '/' + this.fileDownloadTo.substring(4,6) + '/' + this.fileDownloadTo.substring(6,8);
      return '' + testFormatFrom + ' - ' + testFormatTo;
    },
    getAnalyticsFileDownload() { //파일 다운로드 링크 가져오는 api 호출
      let params = {};
      let currentUserCd = this.$store.getters.getUserunisCustomerCd;
      if(this.$route.query.unisCustomerCd!= undefined && currentUserCd != this.$route.query.unisCustomerCd) {
          currentUserCd = this.$route.query.unisCustomerCd;
      }
      this.networkController.getAnalyticsFileDownload(params, this.mode, this.fileDownloadFrom, this.fileDownloadTo, currentUserCd)
      .then(async (res) => {
        this.fileDownloadLink = res.data.link;
        this.fileDownloadStatus = 'downloadReady'
        if(this.pageName == 'allStoreAnalytics') { 
          this.fileDownloadData.allStoreAnalyticsCsvUrl = res.data.link;
        }
        else if(this.pageName == 'storeAnalyze') {
          this.fileDownloadData.storeAnalyzeCsvUrl = res.data.link;
        }
        else if(this.pageName == 'otherStoreAnalyze') {
          this.fileDownloadData.otherStoreAnalyzeCsvUrl = res.data.link;
        }
        this.$store.commit('setFileDownloadData', this.fileDownloadData);
      }).catch(error => {
        this.fileDownloadStatus = 'downloadFail'
      });
    },
    toDownloadSuccess() { //다운로드 클릭 시에만 url 삭제
      this.fileDownloadData.allStoreAnalyticsCsvUrl = '';
      this.fileDownloadData.storeAnalyzeCsvUrl = '';
      this.fileDownloadData.otherStoreAnalyzeCsvUrl = '';
      this.$store.commit('setFileDownloadData', this.fileDownloadData);
      this.fileDownloadStatus = 'downloadSuccess'
    },
    formatFilePeriod(d, mode, fromToValue) { //파일 from, to 데이터 문자열로 변경
      if(mode == 'hour') {
        if(fromToValue == 'from'){
          return '' + d.year + (d.month >= 10 ? d.month : '0' + d.month) + (d.date >= 10 ? d.date : '0' + d.date) + '00';
        }
        else{
          return '' + d.year + (d.month >= 10 ? d.month : '0' + d.month) + (d.date >= 10 ? d.date : '0' + d.date) + (d.hour >= 10 ? d.hour : '0' + d.hour);
        }
      } else {
        if(fromToValue == 'from')
          return '' + d.year + (d.month >= 10 ? d.month : '0' + d.month) + (d.date >= 10 ? d.date : '0' + d.date);
        else
          return '' + d.year + (d.month >= 10 ? d.month : '0' + d.month) + (d.date >= 10 ? d.date : '0' + d.date);
      }
    },
    getFileDownloadData() { //store에서 file download data 가져오기
      this.fileDownloadData = this.$store.getters.getFileDownloadData;
      if(this.fileDownloadData.unisCustomerCd == this.unisCustomerCd) {
        //pageName에 따라서 버튼의 url 변경, url이 있을 때만 downloadReady
        if(this.pageName == 'allStoreAnalytics' && this.fileDownloadData.allStoreAnalyticsCsvUrl != "") { 
          this.fileDownloadStatus = 'downloadReady'
          this.fileDownloadLink = this.fileDownloadData.allStoreAnalyticsCsvUrl;
        }
        else if(this.pageName == 'storeAnalyze' && this.fileDownloadData.storeAnalyzeCsvUrl != "") {
          this.fileDownloadStatus = 'downloadReady'
          this.fileDownloadLink = this.fileDownloadData.storeAnalyzeCsvUrl;
        }
        else if(this.pageName == 'otherStoreAnalyze' && this.fileDownloadData.otherStoreAnalyzeCsvUrl != "") {
          this.fileDownloadStatus = 'downloadReady'
          this.fileDownloadLink = this.fileDownloadData.otherStoreAnalyzeCsvUrl;
        }
      } else {
        this.fileDownloadData.unisCustomerCd = this.unisCustomerCd;
        this.fileDownloadData.allStoreAnalyticsCsvUrl = '';
        this.fileDownloadData.storeAnalyzeCsvUrl = '';
        this.fileDownloadData.otherStoreAnalyzeCsvUrl = '';
        this.$store.commit('setFileDownloadData', this.fileDownloadData);
      }
    },
    refreshFileDownload() { //파일 다운로드 status 리셋 및 다운로드 기간 정의
      this.fileDownloadStatus = 'makeFile'
      let fileFromDate = this.leftSide;
      let fileToDate = {
        year: new Date().getFullYear(),
        month: new Date().getMonth()+1,
        date: new Date().getDate(),
        hour: new Date().getHours()
      }

      //status 리셋 시 url도 함께 리셋
      this.fileDownloadData.allStoreAnalyticsCsvUrl = '';
      this.fileDownloadData.storeAnalyzeCsvUrl = '';
      this.fileDownloadData.otherStoreAnalyzeCsvUrl = '';

      //모드별 분기
      if(this.mode == 'hour') { //시간별
        this.modeText = this.$i18n.t('lang.allStoreAnalytics.hourly');
      } else if(this.mode == 'day') { //일별
        this.modeText = this.$i18n.t('lang.allStoreAnalytics.daily');
      } else if(this.mode == 'week') { //주간
        this.modeText = this.$i18n.t('lang.allStoreAnalytics.week');
      } else if(this.mode == 'month') { //월간
        this.modeText = this.$i18n.t('lang.allStoreAnalytics.month');
      } else { //3월간
        this.modeText = '3' + this.$i18n.t('lang.allStoreAnalytics.month');
      }

      //기간별 분기
      if(this.period == '7day') { //7일
        const today = new Date();
        const priorDate = new Date(new Date().setDate(today.getDate() - 6));

        fileFromDate = this.makeFileFromToDate(priorDate);
      }
      else if(this.period == '30day'){ //30일
        const today = new Date();
        const priorDate = new Date(new Date().setDate(today.getDate() - 30));

        fileFromDate = this.makeFileFromToDate(priorDate);
      }
      else if(this.period == 'fromto') { //기간 지정
        if(this.startDate != null) {
          fileFromDate = this.startDate;
          fileToDate = this.endDate;
        }
      }
      this.getFilePeriod(fileFromDate, fileToDate);
    },
    getFilePeriod(fileFromDate, fileToDate) {
      this.fileDownloadFrom = this.formatFilePeriod(fileFromDate, this.mode, 'from'); //hour
      if(this.mode == 'hour' && this.period == 'fromto') { //기간 선택의 hour mode인 경우 23시까지로 고정
        fileToDate.hour = 23;
      }
        
      this.fileDownloadTo = this.formatFilePeriod(fileToDate, this.mode, 'to');
      if(this.period == '30day' || this.period == 'fromto') {
        this.$emit('totalVisitorData', {'fileDownloadFrom' : this.fileDownloadFrom, 'fileDownloadTo' : this.fileDownloadTo})
      }
      console.log("file from : " + this.fileDownloadFrom);
      console.log("file to : " + this.fileDownloadTo);
    },
    makeFileFromToDate(d) {
      let dateValue = {};
      if(typeof d === 'string') {
        /*
         * '2020081015'와 같은 형식의 경우
         */
        dateValue.year = d.substring(0,4) * 1;
        dateValue.month = d.substring(4,6) * 1;
        dateValue.date = d.substring(6,8) * 1;
        dateValue.hour = d.substring(8,10) * 1;
      } else {
        /*
         * date('Tue Nov 01 2022 15:38:00 GMT+0900 (한국 표준시)') 형식의 경우
         */
        dateValue.year = d.getFullYear();
        dateValue.month = d.getMonth() + 1;
        dateValue.date = d.getDate();
        dateValue.hour = d.getHours();
      }

      return dateValue;
    },
    toMakeFile() {
      this.refreshFileDownload(); //무조건 refresh 후 makeFile로 상태변경
      this.fileDownloadStatus = 'makeFile'
    }
  }
}
</script>
<style lang="scss" scoped>
.btn_close {
  width: 1.3rem;
  height: 1.3rem;
  position: absolute;
  top: -0.3rem;
  right: -2.3rem;
}
</style>